export const NotFound = () => {
  return <h1>ERROR 404</h1>;
};
